
import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Grid, Step } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import FormHeader from '@abra/elements/headers/Form'

import PrimarySection from './Section/Primary'
import SettingSection from './Section/Setting'

const NoShowDetails = ({ companyContractLabel, company_id, companycontract_id }) => (
  <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
    <Grid container rowSpacing={1}>
      <Grid size={12}>
        {!!companycontract_id ?
          <FormHeader
            subTitle={I18n.t('link.specificparameter')}
            onLinkClick={() => window.open(`/company/${company_id}/contract/${companycontract_id}`, '_blank')}
            linkText={companyContractLabel}
          /> : <FormHeader />
        }
      </Grid>
      <Grid size={12}>
        <GridStepper groupsCount={[3]} activeStep={0} orientation="vertical">
          <Step><PrimarySection /></Step>
          <Step><SettingSection /></Step>
        </GridStepper>
      </Grid>
    </Grid>
  </Box>
)

export default React.memo(NoShowDetails)
